<div
  *ngIf="
    toastService.topBannerMessages.length ||
    toastService.applicationMessages.length
  "
  class="top-banner position-fixed w-100"
>
  <div
    *ngIf="toastService.topBannerMessages.length"
    class="container-fluid top-banner-messages-container"
  >
    <div class="row">
      <div class="col-sm-10 mx-auto">
        <div
          class="top-banner-message"
          *ngFor="let u of toastService.topBannerMessages"
        >
          <div class="row align-items-center">
            <div class="col-sm-10">
              <p class="top-banner-text">
                <span class="bold d-block color-white">{{ u.title }}</span>
                <span class="color-white">{{ u.text }}</span>
              </p>
            </div>
            <div class="col-sm-2 top-banner-times text-center color-white">
              <i (click)="close(u.topBannerMessageId)" class="fal fa-times"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="toastService.applicationMessages.length">
    <div
      *ngFor="let applicationMessage of toastService.applicationMessages"
      class="container-fluid"
      [class.alert-info]="
        applicationMessage.applicationMessageTypeId ===
        ApplicationMessageTypeEnum.Info
      "
      [class.alert-warning]="
        applicationMessage.applicationMessageTypeId ===
        ApplicationMessageTypeEnum.Warning
      "
      [class.alert-danger]="
        applicationMessage.applicationMessageTypeId ===
        ApplicationMessageTypeEnum.Danger
      "
    >
      <div class="row">
        <div class="col-sm-10 mx-auto">
          <div class="top-banner-message">
            <div class="row align-items-center">
              <div class="col-sm-10">
                <p class="top-banner-text">
                  <span class="bold d-block">{{
                    "applicationMessage" | translate
                  }}</span>
                  <span>{{ applicationMessage.message }}</span>
                </p>
              </div>
              <div
                class="col-sm-2 top-banner-times text-center"
                *ngIf="applicationMessage.applicationMessageId != null"
              >
                <i
                  (click)="
                    closeApplicationMessage(
                      applicationMessage.applicationMessageId
                    )
                  "
                  class="fal fa-times"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
<div *ngIf="showBackdrop" class="top-banner-backdrop"></div>
